import { Grid, type GridProps } from '@companydotcom/potion';
import { motion } from 'framer-motion';

export const MotionGrid = motion<GridProps>(Grid);
